<template lang="pug">
.crew-member
	h3.name 
		span.margin-right {{p.name.first}}
		span.margin-right(v-if='p.name.middle') {{p.name.middle[0]}}.
		span.margin-right {{p.name.last}}
		span(v-if='p.name.suffix') {{p.name.suffix}}
	.member-details(v-if="p.code") 
		span.member-code {{p.code}}
		span(v-if="p.ssn")
		span.member-ssn &nbsp;&middot; SSN:  {{p.ssn.slice(-4)}}
	

</template>

<script>
import moment from "moment";

export default {
  name: "CrewMember",
  props: {
    p: null
  },
  data: function() {
    return {
      now: null
    };
  },
  computed: {},
  mounted: function() {
    setInterval(() => {
      this.now = moment();
    }, 1000);
  },
  methods: {}
};
</script>

<style scoped lang="less">
h1 {
  color: black !important;
}
.crew-member {
  text-align: left;
  padding: 0.5rem;
}
.name {
  font-size: larger;
}

.member-code {
  font-family: monospace;
}
.margin-right {
  margin-right: 0.5rem;
}
</style>
